module.exports = __webpack_public_path__ + "img/yema.2e27acf4.png";